/**
 * Helper functions for handling client types (including legacy types)
 */

/**
 * Check if a client type is pallet-based (handles both modern and legacy types)
 * @param clientType - The client type to check ('per_pallet', 'pallet', 'per_sqft', 'sqft')
 * @returns true if the client is pallet-based, false otherwise
 */
export const isPerPalletClient = (clientType: string | undefined | null): boolean => {
  if (!clientType) return false;
  return clientType === 'per_pallet' || clientType === 'pallet';
};

/**
 * Check if a client type is sqft-based (handles both modern and legacy types)
 * @param clientType - The client type to check ('per_pallet', 'pallet', 'per_sqft', 'sqft')
 * @returns true if the client is sqft-based, false otherwise
 */
export const isPerSqftClient = (clientType: string | undefined | null): boolean => {
  if (!clientType) return false;
  return clientType === 'per_sqft' || clientType === 'sqft';
};

/**
 * Normalize client type to modern format
 * @param clientType - The client type to normalize
 * @returns 'per_pallet' or 'per_sqft'
 */
export const normalizeClientType = (clientType: string | undefined | null): 'per_pallet' | 'per_sqft' => {
  if (isPerPalletClient(clientType)) {
    return 'per_pallet';
  }
  return 'per_sqft';
};
